<div [class.required]="model.required" class="ion-text-left question">
  <div>
    <ion-label class="ion-text-wrap">
      {{model.questionResolved}}
    </ion-label>
  </div>
  <textarea placeholder="" [value]="currentValue" class="question-text-area" [class.answerRequired]="model.highlight && (currentValue == null || currentValue == '')"
    [class.diaryTextArea]="isDiary" [disabled]="model.isDisabled" (input)="emitAnswer($event.target.value)"></textarea>
</div>
